export default __webpack_public_path__ + "static/media/2FVISUAL_Slogan.cf8d9c74.png";